import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchCustomFields({ commit }, queryParams = null) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.getCustomFields(
        queryParams,
        resp => {
          let customFields = resp.data;
          resolve(customFields);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchCustomFieldByUuid({ commit }, customFieldUuid) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.getCustomFieldByUuid(
        customFieldUuid,
        resp => {
          let customField = resp.data.data[0];
          resolve(customField);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createCustomField({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.createCustomField(
        newData,
        resp => {
          let customField = resp.data.data;
          resolve(customField);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteCustomFieldByUuid({ commit }, { id, ignoreEntry }) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.deleteCustomFieldByUuid(
        id,
        ignoreEntry,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editCustomField({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.editCustomField(
        newData,
        resp => {
          let customField = resp.data.data;
          resolve(customField);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchCustomLists({ commit }, queryParams = null) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.getCustomLists(
        queryParams,
        resp => {
          let customLists = resp.data;
          resolve(customLists);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchCustomListByUuid({ commit }, customListUuid) {
    const queryParams = {include : "entries"}
    return new Promise((resolve, reject) => {
      API.customListsAndFields.getCustomListByUuid(
        customListUuid,
        queryParams,
        resp => {
          let customList = resp.data.data[0];
          resolve(customList);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createCustomList({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.createCustomList(
        newData,
        resp => {
          let customList = resp.data.data;
          resolve(customList);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editCustomList({ commit }, { newData, listUuid }) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.editCustomList(
        newData,
        listUuid,
        resp => {
          let customList = resp.data.data;
          resolve(customList);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  deleteCustomList({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.deleteCustomList(
        uuid,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  createCustomListValue({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.createCustomListValue(
        newData,
        resp => {
          let customListValue = resp.data.data;
          resolve(customListValue);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editCustomListValue({ commit }, { newData, valueUuid }) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.editCustomListValue(
        newData,
        valueUuid,
        resp => {
          let customListValue = resp.data.data;
          resolve(customListValue);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getCustomListValue({ commit }, valueUuid) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.getCustomListValue(
        valueUuid,
        resp => {
          let customListValue = resp.data.data;
          resolve(customListValue);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteCustomListValue({ commit }, valueUuid) {
    return new Promise((resolve, reject) => {
      API.customListsAndFields.deleteCustomListValue(
        valueUuid,
        resp => {
          let customListValue = resp.data.data;
          resolve(customListValue);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/customListsAndFields.js